import currencyFilter from '../../lib/vue-currency-filter';

const metricFilter = {
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
};

const imperialFilter = {
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'back',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
};

const symbolMapping = {
    GBP: {
        ...imperialFilter,
        symbol: '£',
        symbolPosition: 'front',
    },
    DKK: {
        ...metricFilter,
        symbol: 'kr.',
    },
    NOK: {
        ...metricFilter,
        thousandsSeparator: ' ',
        symbol: 'kr',
    },
    SEK: {
        ...metricFilter,
        symbol: 'kr',
        thousandsSeparator: ' ',
    },
    USD: {
        ...imperialFilter,
        symbol: '$',
        symbolPosition: 'front',
    },
    EUR: {
        ...metricFilter,
        symbol: '€',
        symbolPosition: 'front',
    },
    CALENDAR: {
        ...metricFilter,
        symbolSpacing: false,
        fractionCount: 'none',
    },
};
export const formatPriceMixin = {
    methods: {
        formatPrice(price, currency) {
            return currencyFilter(price, {
                symbol: symbolMapping[currency].symbol || '',
                thousandsSeparator: symbolMapping[currency].thousandsSeparator || metricFilter.thousandsSeparator,
                fractionCount: symbolMapping[currency].fractionCount || metricFilter.fractionCount,
                fractionSeparator: symbolMapping[currency].fractionSeparator || metricFilter.fractionSeparator,
                symbolPosition: symbolMapping[currency].symbolPosition || metricFilter.symbolPosition,
                symbolSpacing: symbolMapping[currency].symbolSpacing || metricFilter.symbolSpacing,
            });
        },
        formatPriceWithoutSymbol(price, currency = null) {
            if (!symbolMapping[currency]) {
                return currencyFilter(price, {
                    symbol: '',
                    thousandsSeparator: metricFilter.thousandsSeparator,
                    fractionCount: metricFilter.fractionCount,
                    fractionSeparator: metricFilter.fractionSeparator,
                    symbolPosition: metricFilter.symbolPosition,
                    symbolSpacing: false,
                });
            }
            return currencyFilter(price, {
                symbol: '',
                thousandsSeparator: symbolMapping[currency].thousandsSeparator || metricFilter.thousandsSeparator,
                fractionCount: symbolMapping[currency].fractionCount || metricFilter.fractionCount,
                fractionSeparator: symbolMapping[currency].fractionSeparator || metricFilter.fractionSeparator,
                symbolPosition: symbolMapping[currency].symbolPosition || metricFilter.symbolPosition,
                symbolSpacing: symbolMapping[currency].symbolSpacing || metricFilter.symbolSpacing,
            });
        },
        formatWithFractionCount(price, fractionCount) {
            return currencyFilter(price, {
                symbol: '',
                thousandsSeparator: metricFilter.thousandsSeparator,
                fractionCount: fractionCount,
                fractionSeparator: metricFilter.fractionSeparator,
                symbolPosition: metricFilter.symbolPosition,
                symbolSpacing: false,
            });
        },
    },
};
